import HttpHeaders, { Header } from './HttpHeaders'

export default HttpHeaders
export { Header }



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Playground/HttpHeaders/index.ts